// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80ec639f","455":"f6ec1a89","977":"647345e2"}[chunkId] + ".chunk.js";
};